import React from 'react'
import Footer from '../../HomeComponents/Footer'
import fetch from '../json/Monday.json'
import ScheduleItem from './ScheduleItem'


export default function Monday() {
  return (
    <>
    <div>
        {fetch && fetch.map(({day, time1, time2, time3, time4, time5, time6, time7, time8, sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8 }) => (
            <div key={day}>
                <ScheduleItem
                day={day}
                time1={time1}
                time2={time2}
                time3={time3}
                time4={time4}
                time5={time5}
                time6={time6}
                time7={time7}
                time8={time8}
                sub1={sub1}
                sub2={sub2}
                sub3={sub3}
                sub4={sub4}
                sub5={sub5}
                sub6={sub6}
                sub7={sub7}
                sub8={sub8}
                />
            </div>
        ))}
    </div>
    
    </>
  )
}
